"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var thirdOrderApi = _interopRequireWildcard(require("@/api/thirdOrderApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      initloading: false,
      loading: false,
      visible: false,
      orderNo: '',
      handerOptions: [{
        value: -2,
        name: '已取消'
      }, {
        value: -1,
        name: '待支付'
      }, {
        value: 0,
        name: '未知'
      }, {
        value: 1,
        name: '进行中'
      }, {
        value: 2,
        name: '充值成功'
      }, {
        value: 3,
        name: '充值失败'
      }],
      orderDetail: {},
      pram: {}
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit() {
      var _this = this;
      var orderDetail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.orderDetail = orderDetail;
      this.pram = {};
      this.visible = true;
      if (!orderDetail.orderNo) return;
      thirdOrderApi.getSettingInfo(orderDetail.orderNo).then(function (res) {
        var _ref = res || {},
          supplierNo = _ref.supplierNo,
          status = _ref.status;
        _this.pram = {
          status: status ? Number(status) : null,
          supplierNo: supplierNo
        };
      });
    },
    handerSubmit: function handerSubmit() {
      var _this2 = this;
      this.$refs['pram'].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        thirdOrderApi.settingOrder(_objectSpread({
          orderNo: _this2.orderDetail.orderNo
        }, _this2.pram)).then(function (data) {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};